import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#debt-to-income-app', App);
